import React, { useState } from 'react';
import { Card, Form, Input, Button, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import api from '../../services/api';

const MyAccount = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (values) => {
    try {
      setLoading(true);
      
      await api.put('/auth/change-password', {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword
      });

      message.success('Senha alterada com sucesso!');
      form.resetFields();
    } catch (error) {
      if (error.response?.status === 401) {
        message.error('Senha atual incorreta');
      } else {
        message.error('Erro ao alterar senha');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <Card title="Minha Conta" style={{ maxWidth: 600 }}>
        <h3 style={{ marginBottom: 24 }}>
          <LockOutlined /> Alterar Senha
        </h3>
        
        <Form
          form={form}
          layout="vertical"
          onFinish={handleChangePassword}
        >
          <Form.Item
            label="Senha Atual"
            name="currentPassword"
            rules={[
              { required: true, message: 'Digite sua senha atual' }
            ]}
          >
            <Input.Password placeholder="Digite sua senha atual" />
          </Form.Item>

          <Form.Item
            label="Nova Senha"
            name="newPassword"
            rules={[
              { required: true, message: 'Digite a nova senha' },
              { min: 6, message: 'A senha deve ter no mínimo 6 caracteres' }
            ]}
          >
            <Input.Password placeholder="Digite a nova senha" />
          </Form.Item>

          <Form.Item
            label="Confirmar Nova Senha"
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: 'Confirme a nova senha' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('As senhas não coincidem'));
                }
              })
            ]}
          >
            <Input.Password placeholder="Confirme a nova senha" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Alterar Senha
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default MyAccount;
